import React, { Component } from 'react'
import $ from 'jquery'
import axios from 'axios';
import { dayChange } from '../../../static/js/Common'
import { DataPicker1 } from '../../picker/DataPicker1';

import '../../../static/css/popup.css';

import closeV2 from '../../../static/image/v2/popup/closeV2.png'
import shopRemoveBtn from '../../../static/image/v2/shop/shopRemoveBtn.png'
import shopAddBtn from '../../../static/image/v2/shop/shopAddBtn.png'
import {closePopup} from "../../../static/js/Common2";
import {getElementRadio } from "../../../utils/CommonUtils";

import CheckBox from "../../elements/CheckBox";
import {setOrderShopApi} from "../../../api/shopApi";
import {getShopMappingApi} from "../../../api/MappingApi";
import {getUuidMake} from "../../../static/js/Common";
import { BACK_OFFICE_API, ORDER_API, POS_API } from 'constants/apiUrls';

class ShopInfo3PopupV2 extends Component {
  async componentDidMount() {
    function selectOut0() {
      document.querySelector('body').addEventListener('click', function(e) {
        if(e.target.className !== 'selectText holidaySelectText') {
          $(`.holidayType`).removeClass('active')
        }
      })
    }

    selectOut0()

    function selectOut1() {
      document.querySelector('body').addEventListener('click', function(e) {
        if(e.target.className !== 'selectText daySelectText') {
          $(`.dayType`).removeClass('active')
        }
      })
    }

    selectOut1()
  }

  selectActive = (e) => {
    var dataHref = e.target.dataset.href

    e.target.parentElement.className = `popupSelect ${ dataHref } active`
  }
  holidaySelect = (e) => {
    var dataIdx = e.target.dataset.id
    var dataName = e.target.dataset.name

    var select = e.target.parentElement.parentElement.querySelector('.selectText')
    var selectHref = select.dataset.href
    select.dataset.idx = dataIdx
    select.dataset.name = dataName
    select.innerText = dataName

    e.target.parentElement.parentElement.className = `popupSelect ${ selectHref }`
  }

  addHoliday = (e) => {
    let dataset = e.target.dataset
    let index = dataset.index
    let zIndex = 200 - Number(index)
    dataset.index = 1 + Number(index)

    let div = document.createElement('div')
    div.innerHTML = `<div class='popupSelect holidayType'>` +
    `<div class='selectText holidaySelectText' data-name='매주' data-id='0' data-idx='1' data-href='holidayType'>매주</div>` +
    `<ul class='selectOptionList'><li class='holidayLi' data-name='매주' data-idx='1' data-href='holidayType'>매주</li>` +
    `<li class='holidayLi' data-name='매달 첫째주' data-idx='3' data-href='holidayType'>매달 첫째주</li><li class='holidayLi' data-name='매달 둘째주' data-idx='4' data-href='holidayType'>매달 둘째주</li>` +
    `<li class='holidayLi' data-name='매달 셋째주' data-idx='5' data-href='holidayType'>매달 셋째주</li><li class='holidayLi' data-name='매달 넷째주' data-idx='6' data-href='holidayType'>매달 넷째주</li>` +
    `<li class='holidayLi' data-name='매달 다섯째주' data-idx='7' data-href='holidayType'>매달 다섯째주</li></ul></div>` +
    `<div class='popupSelect dayType'>` +
    `<div class='selectText daySelectText' data-name='월요일' data-id='0' data-idx='1' data-href='dayType'>월요일</div>` +
    `<ul class='selectOptionList'><li class='holidayLi' data-name='월요일' data-idx='1' data-href='dayType'>월요일</li>` +
    `<li class='holidayLi' data-name='화요일' data-idx='2' data-href='dayType'>화요일</li><li class='holidayLi' data-name='수요일' data-idx='3' data-href='dayType'>수요일</li>` +
    `<li class='holidayLi' data-name='목요일' data-idx='4' data-href='dayType'>목요일</li><li class='holidayLi' data-name='금요일' data-idx='5' data-href='dayType'>금요일</li>` +
    `<li class='holidayLi' data-name='토요일' data-idx='6' data-href='dayType'>토요일</li><li class='holidayLi' data-name='일요일' data-idx='7' data-href='dayType'>일요일</li></ul></div>` +
    `<button type='button' class='deliveryRemoveBtn'><img src='${ shopRemoveBtn }' alt='삭제' /></button>`

    div.setAttribute('class', 'holidayBox')
    div.setAttribute('data-modi', '0')
    div.querySelector('.holidayType').style.zIndex = zIndex
    div.querySelector('.dayType').style.zIndex = zIndex

    $('.holidayListBox').append(div)

    div.querySelector('.deliveryRemoveBtn').addEventListener('click', () => {
      div.remove()
    })
    div.querySelector('.holidaySelectText').addEventListener('click', (e) => {
      e.target.parentElement.className = 'popupSelect holidayType active'
    })
    div.querySelector('.daySelectText').addEventListener('click', (e) => {
      e.target.parentElement.className = 'popupSelect dayType active'
    })

    var holidayLi = div.querySelectorAll('.holidayLi')

    holidayLi.forEach((target) => target.addEventListener('click', (e) => {
      var dataIdx = e.target.dataset.idx
      var dataName = e.target.dataset.name
      var dataHref = e.target.dataset.href

      var select = e.target.parentElement.parentElement.querySelector('.selectText')
      select.dataset.idx = dataIdx
      select.dataset.name = dataName
      select.innerText = dataName

      if(dataHref === 'holidayType') {
        e.target.parentElement.parentElement.className = 'popupSelect holidayType'
      } else {
        e.target.parentElement.parentElement.className = 'popupSelect dayType'
      }
    }))
  }

  HolidayRemove = (e) => {
    let dataset = e.target.dataset
    let periodTpcd = dataset.period
    let dowTpcd = dataset.day
    let shopId = Number(this.props.shopId)

    axios.delete(`${ BACK_OFFICE_API }/shopholiday1`, {
      params: {
        shopId : Number(shopId),
        holidayRegTp : 1,
        periodTpcd: periodTpcd,
        dowTpcd: dowTpcd
      }
    }).then(function() {
      e.target.parentElement.parentElement.remove()
    })
  }

  constructor(props) {
    super(props)

    var startDate = dayChange(new Date())
    var endDate = dayChange(new Date())

    if(props.startDate !== null) {
      startDate = dayChange(new Date(props.startDate))
    }
    if(props.endDate !== null) {
      endDate = dayChange(new Date(props.endDate))
    }

    this.state = {
      startDate: startDate,
      endDate: endDate
    }
  }

  render() {

    let shopId = this.props.shopId
    let propsShopHoliday = this.props.shopHoliday
    let operTimeList = this.props.operTimeList
    var legalHoliday = this.props.legalHoliday
    var shopLegalHoliday = this.props.shopLegalHoliday
    let status = this.props.status;

    if(shopLegalHoliday.length !== 0) {
      $('#holidayToggle').prop('checked',true)
      $('.holidayToggleBox input').addClass('active')
      $('.holidayToggleLabel').text('포함')
    }

    // 시간 제한
    $('.hour').off('keyup').on('keyup', function() {
      if($(this).val() > 23) {
        alert('23시 이상은 설정할 수 없습니다.')
        $(this).val(23)
      } else if($(this).val() < 0) {
        alert('0시 이하는 설정할 수 없습니다.')
        $(this).val(0)
      }
    })
    $('.minutes').off('keyup').on('keyup', function() {
      if($(this).val() > 59) {
        alert('59분 이상은 설정할 수 없습니다.')
        $(this).val(59)
      } else if($(this).val() < 0) {
        alert('0분 이하는 설정할 수 없습니다.')
        $(this).val(0)
      }
    })

    // 시간 설정 유형 선택
    $('.timeRadio').off('click').on('click', function() {
      if($(this).hasClass('timeRadio1') === true) {
        if(Number($(this).val()) === 1) {
          $('.shopInfoTime1Popup .timeInputBox').addClass('hide')
          $('.shopInfoTime1Popup .timeInputBox11').removeClass('hide')
          $('.shopInfoTime1Popup .timeInputBox11 .timeInputTitle').text('매일')
        } else if(Number($(this).val()) === 2) {
          $('.shopInfoTime1Popup .timeInputBox').addClass('hide')
          $('.shopInfoTime1Popup .timeInputBox11').removeClass('hide')
          $('.shopInfoTime1Popup .timeInputBox16').removeClass('hide')
          $('.shopInfoTime1Popup .timeInputBox11 .timeInputTitle').text('평일(월~금)')
          $('.shopInfoTime1Popup .timeInputBox16 .timeInputTitle').text('주말(토,일)')
        } else if(Number($(this).val()) === 3) {
          $('.shopInfoTime1Popup .timeInputBox').removeClass('hide')
          $('.shopInfoTime1Popup .timeInputBox11 .timeInputTitle').text('월')
          $('.shopInfoTime1Popup .timeInputBox16 .timeInputTitle').text('토')
        }
      } else if($(this).hasClass('timeRadio2') === true) {
        if(Number($(this).val()) === 1) {
          $('.shopInfoTime2Popup .timeInputBox').addClass('hide')
          $('.shopInfoTime2Popup .timeInputBox21').removeClass('hide')
          $('.shopInfoTime2Popup .timeInputBox21 .timeInputTitle').text('매일')
        } else if(Number($(this).val()) === 2) {
          $('.shopInfoTime2Popup .timeInputBox').addClass('hide')
          $('.shopInfoTime2Popup .timeInputBox21').removeClass('hide')
          $('.shopInfoTime2Popup .timeInputBox26').removeClass('hide')
          $('.shopInfoTime2Popup .timeInputBox21 .timeInputTitle').text('평일(월~금)')
          $('.shopInfoTime2Popup .timeInputBox26 .timeInputTitle').text('주말(토,일)')
        } else if(Number($(this).val()) === 3) {
          $('.shopInfoTime2Popup .timeInputBox').removeClass('hide')
          $('.shopInfoTime2Popup .timeInputBox21 .timeInputTitle').text('월')
          $('.shopInfoTime2Popup .timeInputBox26 .timeInputTitle').text('토')
        }
      }
    })

    // 시간 등록
    const shopTimeBtnEvent = (type) => {
      const timeType = Number(getElementRadio(`time${type}`));
      const timeList = [];
      let result = true;

      // 각 case 별로 반복되는 코드를 함수로 추출하여 재사용성을 높임
      const getTimeValueLoop = (startIdx, endIdx, selectorType) => {
        for (let i = startIdx; i < endIdx; i++) {
          const timeValue = getTimeValue(type, i + 1, selectorType);
          if (timeValue === "false") {
            alert("시간을 입력해주세요.");
            result = false;
            return false;
          } else if (timeValue !== "pass") {
            timeList.push(timeValue);
          }
        }
      };

      switch (timeType) {
        case 1:
          getTimeValueLoop(0, 7, 1);
          break;
        case 2:
          getTimeValueLoop(0, 5, 1);
          getTimeValueLoop(5, 7, 6);
          break;
        case 3:
          getTimeValueLoop(0, 7, "");
          break;
        default:
          break;
      }

      let newTimeList = [];
      let modifyTimeList = [];
      let deleteTimeList = [];

      timeList.some((value) => {
        if (value.type === 2) {
          const findList = operTimeList.find(time => time.dayOfWeek === value.dayOfWeek) || null;

          if (findList === null) {
            alert("영업시간 먼저 설정해주세요.");
            result = false;
            return true;
          } else {
            // 시간 비교를 위해 "HH:mm"을 분 단위로 변환하는 함수 (익일 포함 처리)
            const timeToMinutes = (start, end) => {
              const toMinutes = (time) => {
                const [hours, minutes] = time.split(":").map(Number);
                return hours * 60 + minutes;
              };

              let startMin = toMinutes(start);
              let endMin = toMinutes(end);

              // 시작보다 종료가 작으면 익일로 간주하여 종료 시간에 24시간 추가
              if (endMin <= startMin) {
                endMin += 1440;
              }

              return [startMin, endMin];
            };

            const [valueStart, valueEnd] = timeToMinutes(value.startTime, value.endTime);
            const [findStart, findEnd] = timeToMinutes(findList.startTime, findList.endTime);

            const startCheck = valueStart >= findStart;
            const endCheck = valueEnd <= findEnd;

            if (!startCheck || !endCheck) {
              alert("설정 시간이 영업시간 범위를 벗어났습니다.");
              result = false;
              return true;
            }
          }
        }

        // 등록
        if (value.id === 0) {
          newTimeList.push({
            type: value.type,
            dayOfWeek: value.dayOfWeek,
            startTime: value.startTime,
            endTime: value.endTime
          });
        } else {
          // 수정
          if (value.type !== 3) {
            modifyTimeList.push({
              id: value.id,
              startTime: value.startTime,
              endTime: value.endTime
            });
          } else {
            // 삭제
            deleteTimeList.push(value.id);
          }
        }
      });

      if (result) {
        let shopData = {};
        if (newTimeList.length > 0) {
          shopData.addOperTimeList = newTimeList;
        }
        if (modifyTimeList.length > 0) {
          shopData.setOperTimeList = modifyTimeList;
        }
        if (deleteTimeList.length > 0) {
          shopData.removeOperTimeIdList = deleteTimeList;
        }

        setOrderShopApi(shopId, shopData).then(() => {
          window.location.reload();
        }).catch((e) => {
          alert("에러가 발생했습니다.");
          console.log(e);
        })
      }
    };

    const getTimeValue = (type, number, selectorType) => {
      const timeInputBox = document.querySelector(`.timeInputBox${type}${number}`);
      const dataId = Number(timeInputBox.getAttribute("data-id"));
      let timeCheck, hour1, minutes1, hour2, minutes2;

      if (selectorType !== "") {
        const selectTimeInputBox = document.querySelector(`.timeInputBox${type}${selectorType}`);
        timeCheck = selectTimeInputBox.querySelector(".timeCheck").checked;
        hour1 = selectTimeInputBox.querySelector(".hour1").value;
        minutes1 = selectTimeInputBox.querySelector(".minutes1").value;
        hour2 = selectTimeInputBox.querySelector(".hour2").value;
        minutes2 = selectTimeInputBox.querySelector(".minutes2").value;
      } else {
        timeCheck = timeInputBox.querySelector(".timeCheck").checked;
        hour1 = timeInputBox.querySelector(".hour1").value;
        minutes1 = timeInputBox.querySelector(".minutes1").value;
        hour2 = timeInputBox.querySelector(".hour2").value;
        minutes2 = timeInputBox.querySelector(".minutes2").value;
      }

      if (timeCheck) {
        if (hour1 !== "" && minutes1 !== "" && hour2 !== "" && minutes2 !== "") {
          return {
            id: dataId,
            type: type,
            dayOfWeek: number,
            startTime: `${('0' + hour1).slice(-2)}:${('0' + minutes1).slice(-2)}`,
            endTime: `${('0' + hour2).slice(-2)}:${('0' + minutes2).slice(-2)}`,
          }
        } else {
          return "false";
        }
      } else {
        if (dataId !== 0) {
          return {
            id: dataId,
            type: 3
          }
        } else {
          return "pass";
        }
      }
    }

    // 체크
    const inputTimeCheck = (className) => {
      const timeInputBox = document.querySelector(`.${className}`);
      const timeCheck = timeInputBox.querySelector(".timeCheck");
      const hour1 = timeInputBox.querySelector(".hour1").value;
      const minutes1 = timeInputBox.querySelector(".minutes1").value;
      const hour2 = timeInputBox.querySelector(".hour2").value;
      const minutes2 = timeInputBox.querySelector(".minutes2").value;

      timeCheck.checked = hour1 !== "" && minutes1 !== "" && hour2 !== "" && minutes2 !== "";
    }

    // 휴무일 토글
    $('.holidayToggleLabel').off('click').on('click', function() {
      if($('.holidayToggleBox input').hasClass('active') === true) {
        $('.holidayToggleBox input').removeClass('active')
        $('.holidayToggleLabel').text('미포함')
      } else {
        $('.holidayToggleBox input').addClass('active')
        $('.holidayToggleLabel').text('포함')
      }
    })

    $('.holidayPopupBtn').off('click').on('click', function() {
      var holidayList = []
      
      $('.holidayBox').each(function() {
        var dataModi = $(this).attr('data-modi')
        var holidayType = $(this).find('.holidayType .selectText').attr('data-idx')
        var dayType = $(this).find('.dayType .selectText').attr('data-idx')

        if(Number(dataModi) !== 1) {
          var data = {
            shopId: shopId,
            holidayTp: 1,
            periodTpcd: Number(holidayType),
            dowTpcd: Number(dayType)
          }

          holidayList.push(data)
        }
      })

        holidayList.sort((a, b) => {
          if(a.periodTpcd !== b.periodTpcd) return a.periodTpcd - b.periodTpcd;
          return a.dowTpcd - b.dowTpcd;
        });

      var holidayToggle = $('#holidayToggle').is(':checked')
      
      $('.lodding').removeClass('hide')

      if(shopLegalHoliday.length === 0) {
        if(holidayToggle === true) {
          legalHoliday.forEach((item, index) => {
            setTimeout(function() {
              axios.post(`${ BACK_OFFICE_API }/shopLegalholiday`, {
                shopId: Number(shopId),
                legalHolidayId: item.id,
                lwUseSta: 1
              })
              
            }, 100 * (index + 1))
          })

          holidayList.forEach((item, index) => {
            setTimeout(function() {
              axios.post(`${ BACK_OFFICE_API }/v2/shopholiday`, {
                shopId: item.shopId,
                holidayRegTp: 1,
                holidayTp: item.holidayTp,
                periodTpcd: item.periodTpcd,
                dowTpcd: item.dowTpcd
              })
              
            }, 100 * (legalHoliday.length + 1))
          })
          setTimeout(function() {
            window.location.reload()
          }, 100 * (legalHoliday.length + holidayList.length + 1))
        } else {
          holidayList.forEach((item, index) => {
            setTimeout(function() {
              axios.post(`${ BACK_OFFICE_API }/v2/shopholiday`, {
                shopId: item.shopId,
                holidayRegTp: 1,
                holidayTp: item.holidayTp,
                periodTpcd: item.periodTpcd,
                dowTpcd: item.dowTpcd
              })
              
            }, 100 * (index + 1))
          })
          setTimeout(function() {
            window.location.reload()
          }, 100 * (holidayList.length + 1))
        }
      } else {
        if(holidayToggle === true) {
          holidayList.forEach((item, index) => {
            setTimeout(function() {
              axios.post(`${ BACK_OFFICE_API }/v2/shopholiday`, {
                shopId: item.shopId,
                holidayRegTp: 1,
                holidayTp: item.holidayTp,
                periodTpcd: item.periodTpcd,
                dowTpcd: item.dowTpcd
              })
              
            }, 100 * (index + 1))
          })
          setTimeout(function() {
            window.location.reload()
          }, 100 * (holidayList.length + 1))
        } else {
          shopLegalHoliday.forEach((item, index) => {
            setTimeout(function() {
              axios.delete(`${ BACK_OFFICE_API }/shopLegalholiday`, {
                params: {
                  shopId: Number(shopId),
                  legalHolidayId: item.legalHolidayId
                }
              })
              
            }, 100 * (index + 1))
          })
  
          holidayList.forEach((item, index) => {
            setTimeout(function() {
              axios.post(`${ BACK_OFFICE_API }/v2/shopholiday`, {
                shopId: item.shopId,
                holidayRegTp: 1,
                holidayTp: item.holidayTp,
                periodTpcd: item.periodTpcd,
                dowTpcd: item.dowTpcd
              })
              
            }, 100 * (shopLegalHoliday.length + 1))
          })
          setTimeout(function() {
            window.location.reload()
          }, 100 * (shopLegalHoliday.length + holidayList.length + 1))
        } 
      }
    })

    // 휴무일 불러오기
    let shopHoliday = [...propsShopHoliday]
      .sort((a, b) => {
        if(a.periodTpcd !== b.periodTpcd) return a.periodTpcd - b.periodTpcd;
        return a.dowTpcd - b.dowTpcd;
      })
      .map((value, index) => {
      $('.priceAddBtn img').attr('data-index', index + 1)

      var type = '매주'
      if(value.periodTpcd === 3) {
        type = '매달 첫째주'
      } else if(value.periodTpcd === 4) {
        type = '매달 둘째주'
      } else if(value.periodTpcd === 5) {
        type = '매달 셋째주'
      } else if(value.periodTpcd === 6) {
        type = '매달 넷째주'
      } else if(value.periodTpcd === 7) {
        type = '매달 다섯째주'
      }

      var day = '월요일'
      if(value.dowTpcd === 2) {
        day = '화요일'
      } else if(value.dowTpcd === 3) {
        day = '수요일'
      } else if(value.dowTpcd === 4) {
        day = '목요일'
      } else if(value.dowTpcd === 5) {
        day = '금요일'
      } else if(value.dowTpcd === 6) {
        day = '토요일'
      } else if(value.dowTpcd === 7) {
        day = '일요일'
      }

      return (
        <div className='holidayBox' data-modi='1' key={ index }>
          <div className='popupSelect holidayType readOnly'>
            <div className='selectText' data-name={ type } data-id='0' data-idx={ value.periodTpcd } data-href='holidayType'>{ type }</div>
            <ul className='selectOptionList'>
              <li data-name='매주' data-idx='1' onClick={ this.holidaySelect }>매주</li>
              <li data-name='매달 첫째주' data-idx='3' onClick={ this.holidaySelect }>매달 첫째주</li>
              <li data-name='매달 둘째주' data-idx='4' onClick={ this.holidaySelect }>매달 둘째주</li>
              <li data-name='매달 셋째주' data-idx='5' onClick={ this.holidaySelect }>매달 셋째주</li>
              <li data-name='매달 넷째주' data-idx='6' onClick={ this.holidaySelect }>매달 넷째주</li>
              <li data-name='매달 다섯째주' data-idx='7' onClick={ this.holidaySelect }>매달 다섯째주</li>
            </ul>
          </div>
          <div className='popupSelect dayType readOnly'>
            <div className='selectText' data-name={ day } data-id='0' data-idx={ value.dowTpcd } data-href='dayType'>{ day }</div>
            <ul className='selectOptionList'>
              <li data-name='월요일' data-idx='1' onClick={ this.holidaySelect }>월요일</li>
              <li data-name='화요일' data-idx='2' onClick={ this.holidaySelect }>화요일</li>
              <li data-name='수요일' data-idx='3' onClick={ this.holidaySelect }>수요일</li>
              <li data-name='목요일' data-idx='4' onClick={ this.holidaySelect }>목요일</li>
              <li data-name='금요일' data-idx='5' onClick={ this.holidaySelect }>금요일</li>
              <li data-name='토요일' data-idx='6' onClick={ this.holidaySelect }>토요일</li>
              <li data-name='일요일' data-idx='7' onClick={ this.holidaySelect }>일요일</li>
            </ul>
          </div>
          <button type='button' className='deliveryRemoveBtn'><img src={ shopRemoveBtn } alt='삭제' data-period={ value.periodTpcd } data-day={ value.dowTpcd } onClick={ this.HolidayRemove } /></button>
        </div>
      )
    })

    $('.shopTempPopupBtn').off('click').on('click', async () => {
      var startDate = $('#startDate').val();
      var endDate = $('#endDate').val();
      var result = true;

      // 오늘 날짜를 yyyy-MM-dd 형식으로 변환
      var today = new Date();
      var todayStr = today.toISOString().split('T')[0];

      // 시작일과 종료일이 모두 비어있을 때 기본값 설정
      if (startDate === "" && endDate === "") {
        startDate = "2000-01-01";
        endDate = "2000-01-01";
      } else {
        if (startDate === "") {
          alert("임시 휴무 기간을 제대로 설정해주세요.");
          return false;
        }
        if (endDate === "") {
          alert("임시 휴무 기간을 제대로 설정해주세요.");
          return false;
        }
      }

      // 오늘 날짜가 임시 휴무 기간에 포함되는지 확인
      if (new Date(startDate) <= new Date(todayStr) && new Date(todayStr) <= new Date(endDate)) {
        const posShopId = await getShopMappingApi(shopId);
        const uuid = getUuidMake(posShopId);
        const posTopShop = await axios.get(`${POS_API}/shop/v2/top-id`, {
          params: {
            shopIdList: Number(posShopId)
          }
        });
        const posTopShopId = posTopShop.data[0].topShopId;

        await axios.put(`${ORDER_API}/shop/v2/${shopId}`, {
          status: 7
        });

        await axios.put(`${POS_API}/shop/v2/status`, {
          uuid: uuid,
          modifierId: Number(posShopId),
          modifierType: 1,
          topShopId: Number(posTopShopId),
          shopId: Number(posShopId),
          shopStatus: Number(7),
          prevShopStatus: Number(status),
          salesEndDateTime: today
        });
      }

      if (result) {
        axios.put(`${ORDER_API}/shop/v2/${shopId}`, {
          tempClosingStartDate: startDate,
          tempClosingEndDate: endDate
        }).then(function() {
          window.location.reload();
        });
      }
    });

    return (
      <div>
        <div id="shopInfoTime1Popup" className='shopInfoTimePopup shopInfoTime1Popup popupV2 hide'>
          <div className='popupContainer width578'>
            <div className='popupTitle'>
              <h2>영업시간 설정</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("shopInfoTime1Popup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>설정방법</div>
                <div className='flexContent timeRadioBox'>
                  <input type='radio' name='time1' className='timeRadio timeRadio1' id='timeRadio1' value={1}  />
                  <label htmlFor='timeRadio1' className='timeLabel'>평일/주말 동일</label>
                  <input type='radio' name='time1' className='timeRadio timeRadio1' id='timeRadio2' value={2} />
                  <label htmlFor='timeRadio2' className='timeLabel'>평일/주말 별도</label>
                  <input type='radio' name='time1' className='timeRadio timeRadio1' id='timeRadio3' value={3} defaultChecked />
                  <label htmlFor='timeRadio3' className='timeLabel'>요일별 개별</label>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox11' data-id='0'>
                <div className='flexTitle timeInputTitle'>월</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time11" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox11");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox11");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox11");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox11");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox12' data-id='0'>
                <div className='flexTitle timeInputTitle'>화</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time12" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox12");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox12");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox12");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox12");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox13' data-id='0'>
                <div className='flexTitle timeInputTitle'>수</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time13" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox13");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox13");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox13");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox13");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox14' data-id='0'>
                <div className='flexTitle timeInputTitle'>목</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time14" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox14");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox14");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox14");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox14");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox15' data-id='0'>
                <div className='flexTitle timeInputTitle'>금</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time15" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox15");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox15");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox15");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox15");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox16' data-id='0'>
                <div className='flexTitle timeInputTitle'>토</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time16" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox16");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox16");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox16");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox16");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1 timeInputBox timeInputBox17' data-id='0'>
                <div className='flexTitle timeInputTitle'>일</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time17" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox17");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox17");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox17");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox17");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("shopInfoTime1Popup")}>취소</button>
              <button type='button' className='shopInfoTimePopupBtn blueBtn' onClick={() => shopTimeBtnEvent(1)}>확인</button>
            </div>
          </div>
        </div>
        <div id="shopInfoTime2Popup" className='shopInfoTimePopup shopInfoTime2Popup popupV2 hide'>
          <div className='popupContainer width578'>
            <div className='popupTitle'>
              <h2>휴식시간 설정</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("shopInfoTime2Popup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>설정방법</div>
                <div className='flexContent timeRadioBox'>
                  <input type='radio' name='time2' className='timeRadio timeRadio2' id='timeRadio4' value={1}  />
                  <label htmlFor='timeRadio4' className='timeLabel'>평일/주말 동일</label>
                  <input type='radio' name='time2' className='timeRadio timeRadio2' id='timeRadio5' value={2} />
                  <label htmlFor='timeRadio5' className='timeLabel'>평일/주말 별도</label>
                  <input type='radio' name='time2' className='timeRadio timeRadio2' id='timeRadio6' value={3} defaultChecked />
                  <label htmlFor='timeRadio6' className='timeLabel'>요일별 개별</label>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox21' data-id='0'>
                <div className='flexTitle timeInputTitle'>월</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time21" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox21");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox21");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox21");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox21");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox22' data-id='0'>
                <div className='flexTitle timeInputTitle'>화</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time22" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox22");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox22");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox22");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox22");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox23' data-id='0'>
                <div className='flexTitle timeInputTitle'>수</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time23" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox23");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox23");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox23");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox23");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox24' data-id='0'>
                <div className='flexTitle timeInputTitle'>목</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time24" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox24");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox24");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox24");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox24");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox25' data-id='0'>
                <div className='flexTitle timeInputTitle'>금</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time25" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox25");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox25");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox25");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox25");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox26' data-id='0'>
                <div className='flexTitle timeInputTitle'>토</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time26" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox26");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox26");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox26");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox26");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox2 timeInputBox timeInputBox27' data-id='0'>
                <div className='flexTitle timeInputTitle'>일</div>
                <div className='flexContent timeInput'>
                  <div className="mb-5">
                    <CheckBox id="time27" className="timeCheck" checked={false} text="영업일" />
                  </div>
                  <input
                    type='number' className='hour hour1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox27");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes1' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox27");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span className='underSpan'>~</span>
                  <input
                    type='number' className='hour hour2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox27");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                  <span>:</span>
                  <input
                    type='number' className='minutes minutes2' maxLength={2}
                    onInput={(e) => {
                      inputTimeCheck("timeInputBox27");
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("shopInfoTime2Popup")}>취소</button>
              <button type='button' className='shopInfoTimePopupBtn blueBtn' onClick={() => shopTimeBtnEvent(2)}>확인</button>
            </div>
          </div>
        </div>

        <div id="shopHolidayPopup" className='shopHolidayPopup popupV2 hide'>
          <div className='popupContainer width540'>
            <div className='popupTitle'>
              <h2>휴무일 설정</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("shopHolidayPopup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              {/* 공휴일 지원 여부 검증 안됨. 배포에 혼입되지 않게 일단 주석 처리 */}
              {/* <div className='popupFlexBox popupFlexBox1 popupFlexTopBox popupFlexTopBox6'>
                <div className='flexTitle'>공휴일 휴무</div>
                <div className='flexContent'>
                  <div className='holidayToggleBox'>
                    <input type='checkbox' id='holidayToggle' />
                    <label className='holidayToggleLabel' htmlFor='holidayToggle'>미포함</label>
                  </div>
                  <span>※ 포함된 공휴일: 신정, 설날, 삼일절, 부처님오신날, 어린이날, 현충일, 광복절, 추석, 개천절, 한글날, 성탄절</span>
                </div>
              </div> */}
              <div className='popupFlexBox popupFlexTopBox popupFlexTopBox6'>
                <div className='flexTitle'>일반 휴무일</div>
                <div className='flexContent holidayListBox'>
                  { shopHoliday }
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'></div>
                <div className='flexContent'>
                  <button className='priceAddBtn' data-index='0' onClick={ this.addHoliday }>
                    <img src={ shopAddBtn } alt='추가' />
                  </button>
                </div>
              </div>  
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("shopHolidayPopup")}>취소</button>
              <button type='button' className='holidayPopupBtn blueBtn'>확인</button>
            </div>
          </div>
        </div>
        <div id="shopTempPopup" className='shopTempPopup popupV2 hide'>
          <div className='popupContainer width540'>
            <div className='popupTitle'>
              <h2>임시 휴무 설정</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("shopTempPopup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
              <div className='popupFlexBox popupFlexBox1 popupFlexTopBox popupFlexTopBox6'>
                <div className='flexTitle'>임시 휴무</div>
                <div className='flexContent shopTempBox'>
                  <DataPicker1 id='startDate' day={ new Date(this.state.startDate) } />
                  <span>~</span>
                  <DataPicker1 id='endDate' day={ new Date(this.state.endDate) } />
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("shopTempPopup")}>취소</button>
              <button type='button' className='shopTempPopupBtn blueBtn'>확인</button>
            </div>
          </div>
        </div>
      </div>
      
    )
  }
}

export { ShopInfo3PopupV2 };